/**
 * Similar to a Party, but tied to a content livestream which provides music.
 */

import * as React from "react";

import { Configuration, getJitsiRoomName } from "../common";
import DanceFloor from "./DanceFloor";
import { JitsiManager } from "./data";
import styles from "./Party.module.css";

interface StreamPartyProps {
    // takes precedence over other content options, if supplied
    contentEmbedUrl?: string;

    twitchChannel?: string;
    livestreamChannel?: {
        account: number;
        event: number;
    };
    vimeoEvent?: string;

    isHost?: boolean;
    hideSelfView?: boolean;
    hideEmbed?: boolean;
}

export default class extends React.Component<StreamPartyProps> {
    public readonly displayName = "StreamParty";
    public static defaultProps: Partial<StreamPartyProps> = {
        isHost: false,
        hideSelfView: false,
    };

    public componentDidMount() {
        const { twitchChannel, vimeoEvent } = this.props;
        // set document title
        if (typeof document !== "undefined") {
            let title = Configuration.DEFAULT_DOCUMENT_TITLE;
            if (twitchChannel !== undefined) {
                title = `digital dance hall: ${twitchChannel}`;
            } else if (vimeoEvent !== undefined) {
                title = `digital dance hall: ${vimeoEvent}`;
            }
            document.title = title;
        }
    }

    public render() {
        return (
            <div className={styles.container}>
                <JitsiManager
                    roomName={getJitsiRoomName(this.props)}
                    // TODO
                    isHost={false /* this.props.isHost */}
                    useHighQualityAudio={false}
                >
                    {(props) => (
                        <DanceFloor
                            {...props}
                            bottomRightView={this.renderStreamEmbed()}
                            showHostAudioOptions={false}
                            hideSelfView={this.props.hideSelfView}
                            hideHostView={this.props.hideEmbed}
                        />
                    )}
                </JitsiManager>
            </div>
        );
    }

    private renderStreamEmbed = () => {
        const { contentEmbedUrl, twitchChannel, vimeoEvent, livestreamChannel } = this.props;

        if (contentEmbedUrl !== undefined) {
            return <iframe src={contentEmbedUrl} width="100%" height="100%" />;
        } else if (twitchChannel !== undefined) {
            const host = process.env.NODE_ENV === "development" ? "localhost" : "digital-dance-hall.netlify.app";
            return (
                <iframe
                    src={`https://player.twitch.tv/?channel=${twitchChannel}&parent=${host}`}
                    width="100%"
                    height="100%"
                />
            );
        } else if (vimeoEvent !== undefined) {
            return (
                <iframe
                    src={`https://player.vimeo.com/video/${vimeoEvent}`}
                    width="100%"
                    height="100%"
                    frameBorder={0}
                    allow="autoplay; fullscreen"
                    allowFullScreen={true}
                />
            );
        } else if (livestreamChannel !== undefined) {
            // e.g. https://livestream.com/accounts/25639407/events/9038641/player?width=960&amp;height=540&amp;enableInfoAndActivity=true&amp;defaultDrawer=feed&amp;autoPlay=true&amp;mute=false
            return (
                <iframe
                    src={`https://livestream.com/accounts/${livestreamChannel.account}/events/${livestreamChannel.event}/player?enableInfoAndActivity=true&amp;defaultDrawer=feed&amp;autoPlay=true&amp;mute=false`}
                    width="100%"
                    height="100%"
                />
            );
        }

        return null;
    };
}
